export var ReminderType;
(function (ReminderType) {
    ReminderType["Action"] = "action";
    ReminderType["Informational"] = "informational";
    ReminderType["Linked"] = "linked";
})(ReminderType || (ReminderType = {}));
